import React, { useState } from "react";
import Axios from "axios";
import { NotificationManager } from "react-notifications";
import useLanguage from "../../hooks/language";
import { Button } from "../../components";
import PhoneAppointment from "../../models/phone-appointment";
import ENDPOINTS from "../../utils/endpoints";
import useAnalytics from "hooks/analytics";
import { UserActionEvent } from "utils/analytics/events";

interface RejectPhoneAppointmentModalProps {
    onClose?: () => void;
    onConfirm?: (appointment: PhoneAppointment) => void;
    appointment?: PhoneAppointment;
}

const RejectPhoneAppointmentModal: React.FunctionComponent<RejectPhoneAppointmentModalProps> = ({
    onClose,
    onConfirm,
    appointment,
}: RejectPhoneAppointmentModalProps) => {
    const { translations } = useLanguage();
    const t = translations.appointmentsSection;
    const [analytics] = useAnalytics();

    // States

    const [loading, setLoading] = useState(false);

    // Network

    const rejectAppointment = async () => {
        if (!appointment) return;

        setLoading(true);

        try {
            await Axios.put(ENDPOINTS.REJECT_PHONE_APPOINTMENT(appointment.id));

            if (onConfirm) {
                onConfirm(appointment);
            }

            analytics
                ?.cdp()
                ?.trackEvent(UserActionEvent.ScreeningPrepAppointmentCancelled);

            NotificationManager.success(
                t.cancellationModal.phoneAppointmentRejected
            );
        } finally {
            setLoading(false);
        }
    };

    // Rendering

    return (
        <div>
            {appointment?.type === "PREP_ELIGIBILITY" && (
                <p>{t.cancellationConfirmModal.prepEligibility}</p>
            )}
            <div>
                <Button onClick={onClose} type="secondary" disabled={loading}>
                    {t.cancellationConfirmModal.exitButtonText}
                </Button>
                <Button
                    onClick={rejectAppointment}
                    type="primary"
                    loading={loading}
                >
                    {t.cancellationConfirmModal.confirmButtonText}
                </Button>
            </div>
        </div>
    );
};

export default RejectPhoneAppointmentModal;
